import { FactoryTypes, FieldID } from "../../../models";

export const androidToSamsungSetupWithPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.chargeBothPhonesAndBringAdapter,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText: FieldID.guideContainer.decisionStep.doYouKnowGooglePassword,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findGmailAddress.text,
            image: FieldID.guideContainer.steps.findGmailAddress.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.confirmYourAccount.text,
            image: FieldID.guideContainer.steps.confirmYourAccount.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.checkEmailUsernameList.text,
            image: FieldID.guideContainer.steps.checkEmailUsernameList.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetGmailPassword.text,
            image: FieldID.guideContainer.steps.resetGmailPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.answerSecurityQuestions.text,
            image: FieldID.guideContainer.steps.answerSecurityQuestions.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.useSamsungSmartSwitch.text,
            image: FieldID.guideContainer.steps.useSamsungSmartSwitch.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.downloadSmartSwitch.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images: FieldID.guideContainer.steps.downloadSmartSwitch.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.connectToOldPhoneWithUSB.text,
            image: FieldID.guideContainer.steps.connectToOldPhoneWithUSB.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.tapSmartSwitch.text,
            image: FieldID.guideContainer.steps.tapSmartSwitch.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.tapReceiveData.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images: FieldID.guideContainer.steps.tapReceiveData.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.tapTransferData.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            text: FieldID.guideContainer.steps.tapTransferData.text,
            images: FieldID.guideContainer.steps.tapTransferData.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .enableGoogleServicesAndVerifyAccount.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images:
              FieldID.guideContainer.steps.enableGoogleServicesAndVerifyAccount
                .images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.completeSamsungDataTransfer.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images:
              FieldID.guideContainer.steps.completeSamsungDataTransfer.images,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];

export const androidToSamsungSetupLostPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.makeSurePhoneFullyCharged,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText: FieldID.guideContainer.decisionStep.doYouKnowGooglePassword,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findGmailAddress.text,
            image: FieldID.guideContainer.steps.findGmailAddress.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.confirmYourAccount.text,
            image: FieldID.guideContainer.steps.confirmYourAccount.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.checkEmailUsernameList.text,
            image: FieldID.guideContainer.steps.checkEmailUsernameList.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetGmailPassword.text,
            image: FieldID.guideContainer.steps.resetGmailPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.answerSecurityQuestions.text,
            image: FieldID.guideContainer.steps.answerSecurityQuestions.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.samsungSetupTerms.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images: FieldID.guideContainer.steps.samsungSetupTerms.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.samsungSetupCopyAppsandData.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images:
              FieldID.guideContainer.steps.samsungSetupCopyAppsandData.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.samsungSetupRestoreData.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images: FieldID.guideContainer.steps.samsungSetupRestoreData.images,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];
